import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef, useState } from "react";
import { FadeIn, FadeOut } from "./ModalFade";
import { DebugLog } from "../HelperFunctions";
import "./PasswordReset.css";
import FocusTrap from "focus-trap-react";
export const PasswordReset = (props) => {
    const [triggerFadeIn, setTriggerFadeIn] = useState(false);
    const [inputError, setInputError] = useState(false);
    const [propHasSetEmail, setPropHasSetEmail] = useState(false);
    const doneInitialEmailFocus = useRef(false);
    let email = "";
    // KEEP: emailTemp is null w/o delay
    if (!doneInitialEmailFocus.current)
        setTimeout(() => {
            email = props.EmailAddress;
            const emailTemp = document.getElementById("PWR_EmailInput");
            if (emailTemp) {
                if (!propHasSetEmail) {
                    emailTemp.value = email;
                    setPropHasSetEmail(true);
                }
                DebugLog("setting timeout focus");
                emailTemp.focus();
                doneInitialEmailFocus.current = true;
            }
        }, 10);
    const reset = () => {
        const emailInput = document.getElementById("PWR_EmailInput");
        if (emailInput && emailInput.value !== "" && emailInput.validity.valid) {
            fadeBackIn();
            props.Submit(emailInput.value);
        }
        else {
            DebugLog("Invalid email address");
            setInputError(true);
            setTimeout(() => {
                var _a;
                (_a = document.getElementById("PWReset_ErrorContainer")) === null || _a === void 0 ? void 0 : _a.focus();
            }, 50);
        }
    };
    const resetError = () => {
        setInputError(false);
    };
    const cancel = () => {
        fadeBackIn();
        props.Submit("");
    };
    const fadeBackIn = () => {
        setTriggerFadeIn(true);
    };
    const SetEmail = (e) => {
        email = e.target.value;
    };
    return (_jsxs(_Fragment, { children: [!triggerFadeIn && (_jsx(FocusTrap, { children: _jsxs("div", Object.assign({ id: "PW_Reset_Container" }, { children: [_jsx("img", { src: "./Images/Misc/Popup_Background.svg", alt: "popup_background" }), _jsxs("span", Object.assign({ id: "PWR_HeaderSpan" }, { children: ["Please enter your email address. ", _jsx("br", {}), "We will send you an email to begin the password reset process."] })), _jsx("span", Object.assign({ id: "PWR_TextInputLabel" }, { children: "Email Address" })), _jsx("input", { id: "PWR_EmailInput", type: "email", "aria-label": "email to reset", onChange: (e) => SetEmail(e) }), inputError && (_jsx("a", Object.assign({ href: "", id: "PWReset_ErrorContainer", className: "ErrorContainer", style: { color: "#747474" }, tabIndex: 0, onBlur: resetError }, { children: _jsx("div", Object.assign({ id: "PWReset_ErrorPopup" }, { children: _jsx("p", Object.assign({ role: "alert" }, { children: "Invalid Email Input" })) })) }))), _jsx("button", Object.assign({ id: "PWR_ResetBtn", onClick: reset, "aria-label": "Reset Password" }, { children: "Reset" })), _jsx("button", Object.assign({ id: "PWR_CancelBtn", onClick: cancel, "aria-label": "Cancel" }, { children: "Cancel" }))] })) })), !triggerFadeIn && _jsx(FadeOut, { isFullFade: false }), triggerFadeIn && _jsx(FadeIn, { isFullFade: false })] }));
};
